import { Component, OnInit, Inject, ViewChild, ElementRef, QueryList, ViewChildren, Input } from '@angular/core';
import { DOCUMENT} from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA,
         MatButtonToggleGroup,MatChipInputEvent, MatAutocompleteSelectedEvent,
         MatExpansionPanel } from '@angular/material';

import { PageScrollConfig, PageScrollService, PageScrollInstance } from 'ng2-page-scroll';
import { Offer, OfferSearchCriteria, OfferMenuEventType } from '../../models/offer';
import { SearchType } from '@app/shared/models/media';
import { OfferAsset } from '../../models/offerAsset';
import { Product, ProductSearchCriteria,ProductMenuEventType } from '../../models/product';
import { Disclaimer } from '../../models/disclaimer';
import { PublicOfferExtraInfos } from '../../models/publicOfferExtraInfos';
import { Media, MediaSearchCriteria } from '../../models/media';
import { ProductLineItem } from '../../models/productLineItem';
import { Job, DocumentSegment, OfferAllocation, OfferType, User } from '@app/shared/';
import { Decoration } from '@app/shared/models/decoration';
import { PublicOfferAsset } from '@app/shared/models/publicOfferAsset';
import { JobUtils } from '@app/shared/utils/job-utils';

import { Store } from '@ngrx/store';
import { AppState, selectOfferState, selectProductState, selectAuthState, selectMediaState } from '@app/store/app.states';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { map, startWith, switchMap, debounceTime, distinctUntilChanged, withLatestFrom } from 'rxjs/operators';

import { GetOffers, OfferActionTypes, UpdateOffer, GetFaveOffers, GetOffer, GetOfferTypes, GetInactiveOfferType, GetHSSCodes, GetAltFields, GetFields, GetPreferences } from '@app/store/actions/offer.actions';
import { GetProducts, ProductActionTypes, GetProductMedia, GetAllProductsMedia } from '@app/store/actions/product.actions';
import { GetMedias, MediaActionTypes, GetDecorations } from '@app/store/actions/media.actions';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { MatAutocompleteTrigger } from '@angular/material';
import { NGXLogger } from 'ngx-logger';

import { NgxImageGalleryComponent, GALLERY_IMAGE, GALLERY_CONF } from "ngx-image-gallery";
import { PairsObservable } from 'rxjs/observable/PairsObservable';

@Component({
  selector: 'app-offer-editor',
  templateUrl: './offer-editor.component.html',
  styleUrls: ['./offer-editor.component.scss']
})
export class OfferEditorComponent implements OnInit {

  offerAssetNavs = [
    {type:'faves',label:'Favourites Offers',icon:'star_outline'},
    {type:'products',label:'Product Search',icon:'fastfood'},
    {type:'assets',label:'Product Asset Search',icon:'panorama'},
    {type:'offers',label:'Offers Search',icon:'local_atm'},
  ];

  @Input() showImagePopover:boolean = true;

  @ViewChild('toggleGroup')
  public toggleGroup: MatButtonToggleGroup;

  @ViewChild('container')
  private container: ElementRef;

  // @ViewChild('skuInput')
  // private skuInput : ElementRef;

  @ViewChild('btnSave')
  private btnSave : ElementRef;

  @ViewChild('psb')
  private psb : any;

  @ViewChild('skuInput', {read:MatAutocompleteTrigger})
  private skuInput:MatAutocompleteTrigger;


  @ViewChildren('anchor') anchors : QueryList < ElementRef >;

  selectedOfferNav:string = 'details';
  selectedOfferAssetNav:any;
  selectedOfferPanelIdx:number = 0;
  sideNavOpened:boolean = false;
  allocation:OfferAllocation;
  offer:Offer;
  offers:Offer[];
  faveOffers:Offer[];
  job:Job;
  products:Product[];
  decorations:Decoration[];
  medias:Media[];
  assetSearchProducts:Product[];
  assetSearchMedia:any[];
  documentSegment:DocumentSegment;
  publicOfferAssets:any[] = [];
  publicOfferExtraInfos:any[] = [];
  showAssetNotification:boolean = false;
  showPLINotification:boolean = false;
  productLineInfoItems: FormArray;
  assetLineInfoItems: FormArray;
  nonMemberInfoItems: FormArray;
  isSaving:boolean = false;
  isLoadingAssets:boolean = false;
  isLoadingOffer:boolean = false;
  // skuPlaceholder:string = "SKU";
  selectable = true;
  removable = true;
  skus:Product[] = [];
  filteredSKUS: Observable<Product[]>;
  saveEnabled:boolean = false;
  offerTypes:any[] = [];
  inactiveOfferTypes:any[] = [];
  teamAllocations:OfferAllocation[] = [];
  hssCodes:any[] = [];
  themes:any[] = [];
  fields:any[] = [];
  user:User;
  currentStep:number = 0;                 // used if type vender is selected
  preferences: any;
  dnd:boolean = false;

  selectedOfferType: any;
  selectedOfferTypeStatus: any;
  mandatoryFields: any;
  selectedFields: any;

  showAutocomplete: boolean = false;
  altFields: any;

  private prevSearchStr:string = "";
  private getOfferState$: Observable<any>;
  private getAuthState$: Observable<any>;
  private getProductState$: Observable<any>;
  private getMediaState$: Observable<any>;
  private offerStoreSubscription:Subscription;
  private authStoreSubscription:Subscription;
  private productStoreSubscription:Subscription;
  private mediaStoreSubscription:Subscription;
  private action:string;
  private offerFormGroup:FormGroup;
  private extraOfferFormGroup:FormGroup;
  private productLineFormGroup:FormGroup;
  private extraInfosFormGroup:FormGroup;
  private assetLineFormGroup:FormGroup;

  private separatorKeysCodes = [ENTER, COMMA];
  private maxKeyStrokes = 1;
  // private maxKeyStrokes = 0;

  @ViewChild(NgxImageGalleryComponent) ngxImageGallery: NgxImageGalleryComponent;


  // gallery configuration
  conf: GALLERY_CONF = {
    imageOffset: '0px',
    showDeleteControl: false,
    showImageTitle: false,
  };

  // gallery images
  images: GALLERY_IMAGE[] = [];

  constructor(
    public dialogRef: MatDialogRef<OfferEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private pageScrollService: PageScrollService,
    @Inject(DOCUMENT) private document: any,
    private store:Store<AppState>,
    private formBuilder:FormBuilder,
    private jobUtils:JobUtils,
    private logger:NGXLogger
  ) {

    this.offer = data.offer?data.offer:new Offer();
    this.action = data.action;
    this.job = data.job;
    this.documentSegment = data.documentSegment;
    this.products = [];
    this.allocation = data.allocation;
    this.assetSearchMedia = [];

    PageScrollConfig.defaultDuration = 500;

    this.altFields = [];
    this.mandatoryFields = [];

    // Auth Store Subscription
    this.getAuthState$ = this.store.select(selectAuthState);
    this.authStoreSubscription = this.getAuthState$.subscribe((state) => {
      this.user = state.user;
    });

    // Offer State Subscription
    this.getOfferState$ = this.store.select(selectOfferState);
    this.offerStoreSubscription = this.getOfferState$.subscribe((state) => {
      this.offers = state.offers;
      this.faveOffers = state.favourites;
      this.themes = state.themes;
      this.fields = state.fields;
      this.isLoadingAssets = false;
      this.preferences = state.preferences;

      // if(this.hssCodes.length)
        this.hssCodes = state.hssCodes?state.hssCodes.value.split(','):[];

      if(state.offerTypes)
        this.offerTypes = state.offerTypes;

      if(state.inactiveOfferTypes)
        this.inactiveOfferTypes = state.inactiveOfferTypes;

      if((state.actionType === OfferActionTypes.UPDATE_OFFER_SUCCESS) || (state.actionType === OfferActionTypes.UPDATE_OFFER_FAILURE)){
        this.isSaving = false;

        if(state.showVendorUpload){
            this.currentStep = 1;
            this.offer = state.selectedOffer;
            // resize the window
            let dialog = this.document.querySelector('.canopy-full-screen-dialog');
            dialog.classList.remove('canopy-full-screen-dialog');
            dialog.classList.add('canopy-medium-screen-dialog');

        }

      }

      if(this.themes) {
        var obj = {};
        for(var i=0; i < this.themes.length; i++){

          let altFields = this.themes[i];
          let altFieldKey = altFields.key.toLowerCase();
          let altFieldValue = altFields.value;
            obj[altFieldKey] = altFieldValue;
        }
        this.altFields.push(obj)

      }

      if(this.fields && this.offerFormGroup) {
        this.selectedFields = [{}]
        if(this.fields && this.offerFormGroup.controls.offerType.value) {
          this.selectedOfferType = this.offerFormGroup.controls.offerType.value.name;
          this.selectedOfferTypeStatus = this.offerFormGroup.controls.offerType.value.statusName;
        }

        for(var i=0; i < this.fields.length; i++){
          let offer = this.fields[i];
          if(this.selectedOfferType === offer.offer_type) {
            this.mandatoryFields = offer.mandatory_fields;
            this.selectedFields = []
            var obj = {};
            for(var j=0; j < this.mandatoryFields.length; j++){

              let manfields = this.mandatoryFields[j]
              obj[manfields] = manfields;
              obj[manfields] = manfields;
            }
            this.selectedFields.push(obj)
          }
        }
      }

      if(state.actionType === OfferActionTypes.GET_OFFER_SUCCESS && state.selectedOffer){
        // make sure we aren't loading a pre-selected offer
        if(this.offer.uuid === state.selectedOffer.uuid){
          this.offer = state.selectedOffer;

          // remove timezone from datestring
          if(this.offer.previousDateString)
            this.offer.previousDateString = this.offer.previousDateString.toString().replace('Z', '');

          if(this.offerFormGroup && this.offerFormGroup.controls.offerType.value != null) {
            this.selectedOfferType = this.offerFormGroup.controls.offerType.value.name;
            this.selectedOfferTypeStatus = this.offerFormGroup.controls.offerType.value.statusName;
          }
            

          this.patchFormValues(this.offer);

          this.isLoadingOffer = false;

          let products = [];
          // need to add the public offer assets
          if(this.offer.publicOfferAssets){
            for(let poa of this.offer.publicOfferAssets){

              if(poa.product){
                this.addPublicOfferAsset(poa);
                products.push(poa.product);
              }

              if(poa.decoration)
                this.addDecoration(poa);

              if(poa.media && !poa.product)
                this.addMedia(poa);
            }
          }

          this.getAllProductsMedia(products);

          // if(this.offer.publicDecorationAssets){
          //   for(let pda of this.offer.publicDecorationAssets){
          //     this.addDecoration(pda);
          //   }
          // }

          if(this.productLineFormGroup) {
            let productLineControls = this.productLineFormGroup.controls.items['controls'];
            let productItemVal = this.productLineFormGroup.controls.items.value;
            let offerControls = this.offerFormGroup.controls;
            // SEG-85
            // for(let i=0; i < productItemVal.length; i++){
            //     if (productItemVal[i].liner === true) {
            //       offerControls.callout.disable();
            //       offerControls.compPriceUnit.disable();
            //       offerControls.contentUnitUom.disable();
            //       offerControls.fromSavings.disable();
            //       offerControls.heroSaveStatement.disable();
            //       offerControls.multiBuyQuantity.disable();
            //       offerControls.netContent.disable();
            //       offerControls.offerDescr.disable();
            //       offerControls.percentOff.disable();
            //       offerControls.previousPrice.disable();
            //       offerControls.salesIndication.disable();
            //       offerControls.saveCombined.disable();
            //       offerControls.saveString.disable();
            //       offerControls.sellCombined.disable();
            //       offerControls.toSavings.disable();
            //       offerControls.unit.disable();
            //       offerControls.wasDate.disable();
            //       offerControls.wasDateInput.disable();
            //     }
            // }

            for(let i=0; i < productLineControls.length; i++){

              if(productLineControls[i].controls.liner.value === false) {
                productLineControls[i].controls.advsavingsvalue.disable();
                productLineControls[i].controls.advsellvalue.disable();
                productLineControls[i].controls.assetDescr.disable();
                productLineControls[i].controls.discounttype.disable();
                productLineControls[i].controls.fromSavings.disable();
                productLineControls[i].controls.productqty.disable();
                productLineControls[i].controls.savePercent.disable();
                productLineControls[i].controls.termType.disable();
                productLineControls[i].controls.toSavings.disable();
                productLineControls[i].controls.uom.disable();
                productLineControls[i].controls.vesselAmount.disable();

                if( this.preferences.poaReadOnly === true) {

                  for(let i=0; i < productItemVal.length; i++){
                      productLineControls[i].controls.advsavingsvalue.disable();
                      productLineControls[i].controls.advsellvalue.disable();
                      productLineControls[i].controls.assetDescr.disable();
                      productLineControls[i].controls.discounttype.disable();
                      productLineControls[i].controls.fromSavings.disable();
                      productLineControls[i].controls.productqty.disable();
                      productLineControls[i].controls.savePercent.disable();
                      productLineControls[i].controls.termType.disable();
                      productLineControls[i].controls.toSavings.disable();
                      productLineControls[i].controls.uom.disable();
                      productLineControls[i].controls.vesselAmount.disable();
                  }
                } else {
                      productLineControls[i].controls.advsavingsvalue.enable();
                      productLineControls[i].controls.advsellvalue.enable();
                      productLineControls[i].controls.assetDescr.enable();
                      productLineControls[i].controls.discounttype.enable();
                      productLineControls[i].controls.fromSavings.enable();
                      productLineControls[i].controls.productqty.enable();
                      productLineControls[i].controls.savePercent.enable();
                      productLineControls[i].controls.termType.enable();
                      productLineControls[i].controls.toSavings.enable();
                      productLineControls[i].controls.uom.enable();
                      productLineControls[i].controls.vesselAmount.enable();
                }
              } else {
                productLineControls[i].controls.advsavingsvalue.enable();
                productLineControls[i].controls.advsellvalue.enable();
                productLineControls[i].controls.assetDescr.enable();
                productLineControls[i].controls.discounttype.enable();
                productLineControls[i].controls.fromSavings.enable();
                productLineControls[i].controls.productqty.enable();
                productLineControls[i].controls.savePercent.enable();
                productLineControls[i].controls.termType.enable();
                productLineControls[i].controls.toSavings.enable();
                productLineControls[i].controls.uom.enable();
                productLineControls[i].controls.vesselAmount.enable();
              }
            }
          }

        }

      }

    });

    // Product State Subscription
    this.getProductState$ = this.store.select(selectProductState);
    this.productStoreSubscription = this.getProductState$.subscribe((state) => {

      switch (state.actionType){

        case ProductActionTypes.GET_PRODUCTS_SUCCESS:{
          if(state.products && (state.searchCriteria && state.searchCriteria.includeAssets))
            this.assetSearchProducts = state.products;
          else if(state.products){
            this.products = state.products;
          }

          if(this.skuInput && !this.skuInput.panelOpen)
            setTimeout(_ => {
              this.logger.debug(this.skuInput.panelOpen, ' panel open');
              this.openAutocomplete();
            },0);

          // this.skuPlaceholder = "SKU";
          this.isLoadingAssets = false;

          break;
        }

        case ProductActionTypes.GET_ALL_PRODUCTS_MEDIA_SUCCESS:{
          //console.log('got media')
          // check which ones have been inlucded in the other assets
          if(!this.productLineFormGroup)
            return;

          var items:any = this.productLineFormGroup.get('items')
          var arrProds = items.controls;

          if(arrProds){
            arrProds.map(asset => {
              if(asset.value.product){
                var selectedMedia;
                var heroImage;
                var product = asset.value.product;
                if(product.media){
                  product.media.map((media:any) => {
                    media.isHero = media.hero;
                    //media.originOwner = this.productOwnerString(asset);

                    if(media.selected) {
                      selectedMedia = media;
                      product.heroMediaURL = selectedMedia.thumbUrl; // BW-837
                    }

                    if(media.isHero) heroImage = media.isHero;
                    
                  })
                }

                let secondaryMedia;
                if(product.productassets) {
                  secondaryMedia = product.productassets.map((media2) => {
                    return media2.media.uuid;
                  })
                }
                
                let allMedia = product.media.map((media2) => {
                  return media2.uuid;
                })

                if(secondaryMedia)
                { 
                  if(secondaryMedia.length !== allMedia.length){
                    product.heroMediaURL;
                  } else if(selectedMedia){
                    product.heroMediaURL = selectedMedia.thumbUrl;
                  }
                  // BW-837 
                  // else if( selectedMedia == undefined && !heroImage && secondaryMedia.length === allMedia.length) {
                  //   if ( product.media[0] )
                  //     product.heroMediaURL = product.media[0].thumbUrl;
                  // }
                }
                //If selectedMedia is true then check/tick alternate media and uncheck hero media
                //If selectedMedia is false and hero is true then check/tick hero media
                // grab the selected media if any
                this.setSeletedProductMedia(product,selectedMedia);
              }
            })
          }

          break;
        }
      }

    });

    // Media State Subscription
    this.getMediaState$ = this.store.select(selectMediaState);
    this.mediaStoreSubscription = this.getMediaState$.subscribe((state) => {
      if(state.decorations && (state.searchCriteria && state.searchCriteria.mediaType === SearchType.DECORATION)){
        this.assetSearchMedia = state.decorations;
      }else{
        this.assetSearchMedia = state.medias;
      }
      this.isLoadingAssets = false;
    });

    // remove timezone from datestring
    if(this.offer.previousDateString)
      this.offer.previousDateString = this.offer.previousDateString.toString().replace('Z', '');


    // create project form group
    this.offerFormGroup = new FormGroup({
      team : new FormControl({value:this.allocation?(!this.allocation.team?this.allocation:this.allocation.team):'',disabled:this.allocation?(this.allocation.team?this.allocation:null):null}),
      position : new FormControl({value:this.allocation?this.allocation:'', disabled:this.allocation?(this.allocation.pagePosition?this.allocation:null):null}),
      //name : new FormControl(this.offer.name,[Validators.required]),
      netContent : new FormControl(this.offer.netContent),
      compPriceUnit : new FormControl(this.offer.compPriceUnit),
      contentUnitUom : new FormControl(this.offer.contentUnitUom),
      wasDateInput : new FormControl({value:this.offer.previousDateString?new Date(this.offer.previousDateString):null}),
      wasDate : new FormControl({value:this.offer.previousDateString?new Date(this.offer.previousDateString):null}),
      callout : new FormControl(this.offer.callout),
      heroSaveStatement : new FormControl(this.offer.heroSaveStatement),
      code : new FormControl({value:this.offer.code,disabled:true}),
      skuList : new FormControl(this.skus),
      offerType : new FormControl(this.offer.offerType,[Validators.required]),
      multiBuyQuantity : new FormControl(this.offer.multiBuyQuantity),
      sellString : new FormControl(this.offer.sellString),
      saveString : new FormControl(this.offer.saveString),
      sellCombined : new FormControl(this.offer.sellCombined),
      saveCombined : new FormControl(this.offer.saveCombined),
      offerName : new FormControl(this.offer.offerName),
      salesIndication : new FormControl(this.offer.salesIndication),
      percentOff : new FormControl(), // what field
      previousPrice : new FormControl(this.offer.previousPrice),

      offerDescr : new FormControl(this.offer.offerDescr),
      //wasDateInput : new FormControl(this.offer.previousDateString),

      unit : new FormControl(this.offer.unit),

      fromSavings : new FormControl(this.offer.fromSavings),
      toSavings : new FormControl(this.offer.toSavings),
      //assetDescr : new FormControl(this.offer.toSavings),
      //unitPrice : new FormControl(this.offer.unitPrice),

    });

    this.extraOfferFormGroup = new FormGroup({
      minSpend : new FormControl(this.offer.minSpend),
      packagedOfferDiscountValue : new FormControl(this.offer.packagedOfferDiscountValue),

      // disclaimer : new FormControl({value:(this.offer.disclaimers && this.offer.disclaimers.length)?this.offer.disclaimers[0].disclaimer:''}),
      disclaimer : new FormControl(this.offer.disclaimers),
      extraNotes : new FormControl(this.offer.extraNotes),
      extraText : new FormControl(this.offer.extraText),
    });

    // need to detect changes as the save is outside the form control scope
    this.offerFormGroup.valueChanges.subscribe(val => {
      var _self = this;
      setTimeout(_ => {
        _self.saveEnabled = _self.canSubmit();
      },10);
    });

    this.productLineFormGroup = this.formBuilder.group({
      items: this.formBuilder.array([])
    });

    this.extraInfosFormGroup = this.formBuilder.group({
      nonMemberNetContent: [''],
      nonMemberContentUnitUom: [''],
      nonMemberSellCombined: [''],
      nonMemberCompPriceUnit: ['']
    });

    this.assetLineFormGroup = this.formBuilder.group({
      items: this.formBuilder.array([])
    });

    let skuControl = this.offerFormGroup.controls.skuList;

    this.filteredSKUS = skuControl.valueChanges
      .pipe(
        startWith(null),
        debounceTime(200),
        distinctUntilChanged(),
        switchMap(val => {
          return this.filterProducts2(val || '')
        })
      );

      //
      // this.filteredSKUS = skuControl.valueChanges.pipe(
      //   startWith(''),
      //   map(product => product ? this.filterProducts(product,this.skus) : this.products.slice())
      // );


    //this.createProductLineItem();
    this.getFaveOffers();
    this.getHSSCodes();

    this.getAltFields();
    this.getFields();
    this.getPreferences();

    if(!this.offerTypes.length){
      this.getOfferTypes();
    }

    this.getInactiveOfferType();

    // if this is an existing offer slight delay to ensure offertypes is called first
    if(this.offer.uuid){
      setTimeout(_ => this.getOfferDetails(),500);
    }

  }

  selectChangeHandler (event: any) {
    this.selectedOfferType = event.value.name;
    for(var i=0; i < this.fields.length; i++){
      let offer = this.fields[i];
      if(this.selectedOfferType === offer.offer_type) {
        this.mandatoryFields = offer.mandatory_fields;
        this.selectedFields = []
        var obj = {};
        for(var j=0; j < this.mandatoryFields.length; j++){

          let manfields = this.mandatoryFields[j]

          obj[manfields] = manfields;
          obj[manfields] = manfields;
        }
        this.selectedFields.push(obj)
      }
    }
  }

  setSeletedProductMedia(product:Product,media:Media):void{
    var tmpMedia;
    // uncheck all
    for(tmpMedia of product.media){
      tmpMedia.selected = false;
    }

    if(media)
      media.selected = true;
    else{
      let hero = product.media.find(val => (val.isHero));
      if(hero)hero.selected = true;
    }

  }
  // filter that returns an observable
  filterProducts2(val: any): Observable<Product[]> {
      // call the service which makes the http-request
      var existing = this.skus;
      return Observable.of(this.products).pipe(
       map(response => response.filter(product => {
         let status = false;

         if(product){

           if(val instanceof Array){
             status = false;
           }else{
            //  status = (product.descr.toLowerCase().indexOf(val.toLowerCase()) > -1
            //            || product.code.toLowerCase().indexOf(val.toLowerCase()) === 0)
              status = (product.code.toLowerCase().indexOf(val.toLowerCase()) === 0)
           }

         }

         if(status && existing){
           let tmpProduct = existing.find(sku => sku === product);
           if(tmpProduct)
             status = false;
         }

         return status;
       })
      )
     );
  }

  openAutocomplete() {
    setTimeout(() => {
      // this.skuInput.openPanel();
      //
      // let skuControl = this.offerFormGroup.controls.skuList;
      //
      // let updateField : Subject<any> = new Subject();
      //
      // this.logger.debug(this.skuInput);
      // const input = this.container.nativeElement.querySelector('.sku-input');
      // input.value = '1111';
      //
      // this.filteredSKUS = skuControl.valueChanges
      //   .pipe(
      //     startWith(null),
      //     debounceTime(200),
      //     distinctUntilChanged(),
      //     switchMap(val => {
      //       return this.filterProducts2(val || '')
      //     })
      //   );
      const skuControl = this.offerFormGroup.controls.skuList;
      this.filteredSKUS = skuControl.valueChanges
        .pipe(
          startWith(null),
          debounceTime(200),
          distinctUntilChanged(),
          switchMap(val => {
            return this.filterProducts2(val || '')
          })
        );

    //  skuControl.valueChanges.withLatestFrom(updateField);
      //this.filteredSKUS.next(customers);

    }, 0)
  }

  ngOnInit() {
    // create a blacnk line item if there are none
    // if(!this.productLineInfoItems)
    //   this.productLineInfoItems = [new ProductLineItem()];

    //this.onOfferAssetToggleClick(this.offerAssetNavs[2]);
  }

  ngAfterViewInit(){
    setTimeout(val=>{
      //this.skus.nativeElement.focus();
    })

      //let onElement = this.renderer2.selectRootElement('#myInput');
    //  onElement.focus();
  }
  public goToHeadingInContainer(targetItem:string): void {
         let pageScrollInstance: PageScrollInstance = PageScrollInstance.newInstance({document: this.document, scrollTarget: targetItem, scrollingViews: [this.container.nativeElement]});
         this.pageScrollService.start(pageScrollInstance);
  };

  public onOfferAssetToggleClick(link:object){
    //this.logger.debug(link);
    // open the sideNav if not sideNavOpened
    this.sideNavOpened = true;
    this.selectedOfferAssetNav = link;

    // set focus to the search field

  }

  public onClose():void{
    console.log(this)
    this.getOfferDetails();
  }

  public onCloseClick():void{
    this.sideNavOpened = false;
    this.toggleGroup.selected = null;
    this.selectedOfferAssetNav = null;

  }

  public onNoClick(): void {
    this.dialogRef.close();
  }

  public getModalTitle():string{
    let title = "Manage Offer";
    if(this.action === OfferMenuEventType.ALLOC_OFFER){
      title = "Allocate Offer";
    }else if(!this.offer.id){
      title = "Create Offer"
    }
    return title;
  }

  onMediaClick(event,assets:any, idx:number = 0):void{
    //console.log(event);
    if(!event.target.classList.contains('mat-checkbox-inner-container')){
      // set the media
      this.loadGalleryImages(assets);
      this.ngxImageGallery.open(idx);
    }
  }

  loadGalleryImages(assets:any):void{
    this.images.splice(0);
    for(var i=0; i < assets.length; i++){
      let asset = assets[i];
      let media:any;
      if(asset.media){
        media = {
          url:asset.media.previewURL,
          altText: asset.media.originalFilename,
          title:asset.media.originalFilename,
          thumbnailUrl: asset.media.thumbUrl
        }

        this.images.push(media);
      }else if(asset.thumbUrl){
        media = {
          url:asset.previewURL,
          altText: asset.originalFilename,
          title:asset.originalFilename,
          thumbnailUrl: asset.thumbUrl
        }
        this.images.push(media);
      }
    }
  }

  getProductMedia(val:Product):void{
    const payload = {products:[val],offer:this.offer};
    this.store.dispatch(new GetAllProductsMedia(payload));
  }

  getAllProductsMedia(products:Product[]):void{
    const payload = {products:products,offer:this.offer};
    this.store.dispatch(new GetAllProductsMedia(payload));
  }

  onItemDrop(event):void{
    const ignoreKeys = ['id','uuid'];

    if(event.dragData instanceof Offer){

      this.clearOfferForm();

      let tmpOffer = event.dragData;
      let products = [];
      this.dnd = true;
      // populate the offer fields
      Object.keys(tmpOffer).forEach(key => {
        if(ignoreKeys.indexOf(key) < 0)
          this.offer[key] = tmpOffer[key];
      });

      if(tmpOffer.publicOfferAssets){
        if(this.offers){
          //BW-384 only first offer was displaying product order correctly
          if (event.dragData.id != this.offers[0].id) {
            tmpOffer.publicOfferAssets = tmpOffer.publicOfferAssets.reverse();
          }
        }

        for(let poa of tmpOffer.publicOfferAssets){
          this.addPublicOfferAsset(poa);
          if(poa.product){
            products.push(poa.product);
          }
          if(poa.decoration){
            this.addDecoration(poa);
          }
          if(poa.media && !poa.product){
            this.addMedia(poa);
          }
        }

        if(products.length){
          this.getAllProductsMedia(products);
        }
      }

      // we need to get all the product media

      this.patchFormValues(tmpOffer);
    }else if(event.dragData instanceof Decoration){
      let asset = event.dragData;
      let pda = new PublicOfferAsset();
      pda.decoration = asset;
      this.addDecoration(pda);
    }else if(event.dragData instanceof Media){
      let asset = event.dragData;
      let pda = new PublicOfferAsset();
      pda.media = asset;
      this.addMedia(pda);
    }else{
      // assign the product media to the offer asset.
      // only add if it doens't already exist.
      let asset = event.dragData;
      if(asset.product){
        const exists = this.publicOfferAssets.find(val => val.uuid === asset.product.uuid);

        if(!exists){
          asset.assetDescr = asset.product.descr;
          this.addPublicOfferAsset(asset);
          this.getProductMedia(asset.product);

          let productLineControls = this.productLineFormGroup.controls.items['controls'];
          if( this.preferences.poaReadOnly === true) {
            if(productLineControls[productLineControls.length-1].value.liner === false) {
              let lineItemControls = productLineControls[productLineControls.length-1].controls;
              lineItemControls.advsavingsvalue.disable();
              lineItemControls.advsellvalue.disable();
              lineItemControls.assetDescr.disable();
              lineItemControls.discounttype.disable();
              lineItemControls.fromSavings.disable();
              lineItemControls.productqty.disable();
              lineItemControls.savePercent.disable();
              lineItemControls.termType.disable();
              lineItemControls.toSavings.disable();
              lineItemControls.uom.disable();
              lineItemControls.vesselAmount.disable();
            }
          }
        }
      }


    }
  }

  clearOfferForm():void{
    let plis = this.productLineFormGroup.get('items').value;
    for(let pli of plis){
        this.removeSKU(pli.product);
    }
  }

  createProductLineItem(val:ProductLineItem): FormGroup {
    //this.logger.debug(val);
    let pli = new ProductLineItem();
    pli.product = val.product;
    return this.formBuilder.group({
      // id: val.id?val.id:'',
      id: (this.dnd === true && this.action === "EDIT_OFFER")?(val.id?'':val.id):(val.id?val.id:''),
      termType: val.termType?val.termType:'',
      advsellvalue: val.advsellvalue?val.advsellvalue:'',
      advsavingsvalue: val.advsavingsvalue?val.advsavingsvalue:'',
      product: val.product,
      featureCode:val.featureCode?val.featureCode:'',
      discounttype:val.discounttype?val.discounttype:'',
      productqty:val.productqty?val.productqty:'',
      uom:val.uom?val.uom:'',
      vesselAmount:val.vesselAmount?val.vesselAmount:'',
      isHero:val.featureCode && val.featureCode === 'Yes'?true:false,
      fromSavings:val.fromSavings?val.fromSavings:'',
      toSavings:val.toSavings?val.toSavings:'',
      savePercent:val.savePercent?val.savePercent:'',
      salesPlan:val.salesPlan?val.salesPlan:'',
      assetDescr:val.assetDescr?val.assetDescr:val.product.descr,
      liner: (val.liner||val.liner != null)?(val.liner === 'N'?false:true):val.liner === 'N',
      // assetDescr:val.assetDescr?val.assetDescr:'',
    });
  }

  removeProductLine(val:Product):void{
    let items = this.productLineInfoItems.value;

    items.forEach((element,index)=>{
      if(element.product.id == val.id) {
        this.productLineInfoItems.controls.splice(index, 1);
        items.splice(index, 1);
      }
    });
  }

  removeProductLineOffers(val:Product):void{
    let items = this.productLineInfoItems.value;
    for(let i = 0; i< items.length; i++){
      if(items[i].product.id === val.id){
        //BW-361
        this.productLineInfoItems.controls.splice(i);
        // this.productLineInfoItems.controls.splice(i, 1);
        break;
      }
    }
    // this.productLineFormGroup.patchValue({items: items});
    // let index = this.publicOfferAssets.indexOf(product, 0);
    // if (index > -1) {
    //    this.publicOfferAssets.splice(index, 1);
    // }
  }

  addNewProductLine(val:ProductLineItem):void{

    if(this.productLineFormGroup){
      // only add if this line for this product doesn't exist.
      this.productLineInfoItems = this.productLineFormGroup.get('items') as FormArray;

      // check whether asset already exists
      let check = this.productLineInfoItems.value.find(obj => {
        return obj.product.id === val.id;
      });

      if(!check){

        this.showPLINotification = true;
        setTimeout(_ => {
          this.showPLINotification = false;
        },5000)
        this.productLineInfoItems.push(this.createProductLineItem(val));

      }
    }

    // let item = new ProductLineItem();
    // this.productLineInfoItems.push(item);
  }

  // add an asset to the public offer
  addPublicOfferAsset(asset:any):void{
    //console.log(' asset ', asset)
    if(!this.publicOfferAssets)
      this.publicOfferAssets = [];

    var product:Product;
    for(let i = 0; i<this.publicOfferAssets.length;i++){

      // if product exists then add it to the product media;
      // if(this.publicOfferAssets[i].id === asset.product.id){ //BW-361
      if(this.publicOfferAssets[i].id === asset.id){
        product = this.publicOfferAssets[i].product;
      }
    }

    if(!product && asset.product){
      product = new Product();
      product.id = asset.product.id;
      product.productassets = [];
      product.uuid = asset.product.uuid;
      product.code = asset.product.code;
      product.descr = asset.product.descr
      // product.termType = asset.product.termType;
      // product.unit = asset.product.unit;

      this.publicOfferAssets.push(product);
    }

    let check = false;
    if(product){
      check = product.productassets.find(obj => {
        return obj.id == asset.media.id;
      });
    }

    if(check || !product)
      return;

    setTimeout(_ => {
      this.showAssetNotification = false;
    },2000)

    // add to public offer assets
    //this.publicOfferAssets.push(asset);
    if(asset.media){
      // set the notification then disable
      this.showAssetNotification = true;
      product.productassets.push(asset.media);
    }

    // add to skulist
    this.addSKU(asset.product);

    // add new product line
    this.addNewProductLine(asset);

  }

  removePublicOfferAsset(val:Product):void{
    if(this.publicOfferAssets.length) {
      for(let i = 0; i< this.publicOfferAssets.length; i++){
        if(this.publicOfferAssets[i].id === val.id){
          // remove assets for all media
          if(this.assetLineInfoItems) {
            for(let ali of this.assetLineInfoItems.value){
              if(ali.originOwner === this.productOwnerString(val)){
                this.removeAsset(ali);
              }
            }
          }
  
          this.publicOfferAssets.splice(i, 1);
          break;
        }
      }
    } else {
        if(this.assetLineInfoItems) {
          for(let ali of this.assetLineInfoItems.value){
            if(ali.originOwner === this.productOwnerString(val)){
              this.removeAsset(ali);
            }
          }
        }
    }
    // for(let i = 0; i< this.publicOfferAssets.length; i++){
    //   if(this.publicOfferAssets[i].id === val.id){
    //     this.publicOfferAssets.splice(i, 1);
    //     break;
    //   }
    // }
  }

  removePublicOfferAssetOffers(val:Product):void{
    for(let i = 0; i< this.publicOfferAssets.length; i++){
      if(this.publicOfferAssets[i].id === val.id){
        // remove assets for all media
        //BW-361
        if(this.assetLineInfoItems) {
          for(let ali of this.assetLineInfoItems.value){
            // if(ali.originOwner === this.productOwnerString(val)){
              this.removeAsset(ali);
            // }
          }
        }
        this.publicOfferAssets.splice(i, 1);
        break;
      }
    }
  }

  removePublicOfferAssetMedia(event:any, asset:Media, product:Product):void{

    let prodIdx = product.productassets.indexOf(asset, 0);
    if (prodIdx > -1) {
       product.productassets.splice(prodIdx, 1);
    }

    if(!product.productassets.length){
      let index = this.publicOfferAssets.indexOf(product, 0);
      if (index > -1) {
         this.publicOfferAssets.splice(index, 1);
      }
    }
  }

  removeAsset(val:any):void{

    //if(val.type === SearchType.DECORATION ){
      // remove it from the form
      let items = this.assetLineInfoItems.value;

      for(let i = 0; i< items.length; i++){
        if(items[i].id === val.id && val.id !== ""){
          this.assetLineInfoItems.controls.splice(i, 1);
          items.splice(i, 1);
          break;
        }else if(val.type === SearchType.MEDIA && items[i].media && (items[i].media.uuid === val.media.uuid)){


          // uncheck the product media.
          /*for(var j=0; j<this.offer.publicOfferAssets.length;j++){
            let asset = this.offer.publicOfferAssets[j];
            if(asset && asset.product){
              // loop over the product media and find a match
              let tmpMedia = asset.product.media.find(media => media.uuid === val.media.uuid);
              if(tmpMedia){
                tmpMedia.isHero = false;
                break;
              }
            }

          }*/
          this.assetLineInfoItems.controls.splice(i, 1);
          items.splice(i, 1);
          break;
        }else if(val.type === SearchType.DECORATION && items[i].decoration && (items[i].decoration.id === val.decoration.id)){
          this.assetLineInfoItems.controls.splice(i, 1);
          items.splice(i, 1);
          break;
        }
      }

    //  this.assetLineFormGroup.patchValue({items: items});

    //}
  }


  //////////////////////
  //
  // Decoration
  //
  //////////////////////
  createAssetLineItem(val:any): FormGroup {
    //this.logger.debug(val);
    var fg;

    if(val.decoration){
      fg = this.formBuilder.group({
        id: (this.dnd === true && this.action === "EDIT_OFFER")?(val.id?'':val.id):(val.id?val.id:''),
        type: 'decoration',
        savePercent: val.savePercent?val.savePercent:'',
        rewards: val.rewards?val.rewards:'',
        decoration: val.decoration,
        media:null,
      });
    }else if(val.media){
      fg = this.formBuilder.group({
        id: (this.dnd === true && this.action === "EDIT_OFFER")?(val.id?'':val.id):(val.id?val.id:''),
        type: 'media',
        savePercent: '',
        rewards: '',
        decoration: null,
        originOwner: val.originOwner,
        isHero:val.featureCode && val.featureCode === 'Yes'?true:false,
        media:val.media,
      });
    }
    return fg;
  }

  addNewAssetLine(val:any):void{

    if(this.assetLineFormGroup){
      // only add if this line for this product doesn't exist.
      this.assetLineInfoItems = this.assetLineFormGroup.get('items') as FormArray;
      let check;
      // check whether asset already exists
      if(val.decoration){
        check = this.assetLineInfoItems.value.find(obj => {
          return (obj.decoration && obj.decoration.id === val.decoration.id);
        });
      }else if(val.media){
        check = this.assetLineInfoItems.value.find(obj => {
          return (obj.media && obj.media.uuid === val.media.uuid);
        });
      }

      if(!check){

        this.showAssetNotification = (val.originOwner && val.originOwner.length)?false:true;
        setTimeout(_ => {
          this.showAssetNotification = false;
        },5000)
        this.assetLineInfoItems.push(this.createAssetLineItem(val));

      }
    }

    // let item = new ProductLineItem();
    // this.productLineInfoItems.push(item);
  }

  // add an asset to the public offer
  addDecoration(asset:PublicOfferAsset):void{
    // if(!this.publicDecorationAsset)
    //   this.publicDecorationAsset = [];

    setTimeout(_ => {
      this.showAssetNotification = false;
    },2000)

    // add new product line
    this.addNewAssetLine(asset);

  }

  removeDecoration(val:Decoration):void{

    for(let i = 0; i< this.decorations.length; i++){
      if(this.decorations[i].id === val.id){
        this.decorations.splice(i, 1);
        break;
      }
    }

  }

  // add an asset to the public offer
  addMedia(asset:PublicOfferAsset):void{
    setTimeout(_ => {
      this.showAssetNotification = false;
    },2000)

    // add new product line
    this.addNewAssetLine(asset);
  }

  removeMedia(val:Media):void{
    for(let i = 0; i< this.medias.length; i++){
      if(this.medias[i].id === val.id){
        this.medias.splice(i, 1);
        break;
      }
    }
  }

  getTeamAllocations():OfferAllocation[]{
    let result = [];
    //this.logger.debug(this.skus);
    if(this.documentSegment && this.documentSegment.offerAllocation){

      result = this.documentSegment.offerAllocation.filter(val => {
        if(this.jobUtils.arraysHaveMatch(this.user.departments,[val.department]).length || this.jobUtils.userIsAdmin(this.user)){
          return val;
        }
      });
    }
    return result;
  }

  getJobAllocations():OfferAllocation[]{
    
    let allDepartments = [];
    let result = [];
    

    if (this.data.job.length > 1) {
      this.data.job.map(jobs => {

        jobs.documentSegments.map(jobsDS => {

          jobsDS.offerAllocation.map(jobsDSoa => {
            allDepartments.push(jobsDSoa);
           
          })
        })
      })

      result = allDepartments.filter(val => {
        if(this.jobUtils.arraysHaveMatch(this.user.departments,[val.department]).length || this.jobUtils.userIsAdmin(this.user)){
          return val;
        }
      });

    }
    
    return result;
  }

  getOfferTypes():void{
    this.store.dispatch(new GetOfferTypes({}));
  }
  getInactiveOfferType():void{
    this.store.dispatch(new GetInactiveOfferType({offer:this.offer}));
  }
  getFaveOffers():void{
    this.store.dispatch(new GetFaveOffers({}));
  }
  getHSSCodes():void{
    this.store.dispatch(new GetHSSCodes({}));
  }

  getAltFields():void{
    this.store.dispatch(new GetAltFields({}));
  }

  getFields():void{
    this.store.dispatch(new GetFields({}));
  }

  getPreferences():void{
    this.store.dispatch(new GetPreferences({}));
  }

  getOfferDetails():void{
    //this.logger.debug(this.offer.uuid);
    this.isLoadingOffer = true;
    this.store.dispatch(new GetOffer({offer:this.offer}));
  }
  searchOffers(event):void{

    let searchCriteria = new OfferSearchCriteria();
    searchCriteria.keyword = event.keyword;
    const payload = {searchCriteria: searchCriteria};

    this.store.dispatch(new GetOffers(payload));

    this.isLoadingAssets = true;
  }

  searchProducts(event):void{

    let searchCriteria = new ProductSearchCriteria();
    searchCriteria.keyword = event.keyword;
    searchCriteria.includeAssets = event.includeAssets;
    const payload = {searchCriteria: searchCriteria};

    this.store.dispatch(new GetProducts(payload));

    if(event.includeAssets)
      this.isLoadingAssets = true;
  }

  searchAssets(event):void{

    let searchCriteria = new MediaSearchCriteria();
    searchCriteria.keyword = event.keyword;
    searchCriteria.mediaType = event.type;

    const payload = {searchCriteria: searchCriteria};

    if(event.type === SearchType.MEDIA){
      this.store.dispatch(new GetMedias(payload));
    }else{
      this.store.dispatch(new GetDecorations(payload));
    }


    this.isLoadingAssets = true;
  }

  onScrollY(event:any):void{
    //this.logger.debug(event);
    const offset = this.psb.elementRef.nativeElement.querySelector('h2').offsetHeight + this.psb.elementRef.nativeElement.querySelector('h2').offsetTop;
    const scrollYTop = this.psb.elementRef.nativeElement.getBoundingClientRect().top;
    var minVal = 0;
    var idx = 0;
    var lastIdx = 0;
    var segClass = `details`;
    var currentAnchor;
    this.anchors.forEach(elem=> {

      //if(elem.nativeElement.name == ){
        let top = elem.nativeElement.getBoundingClientRect().top - scrollYTop -offset;

        minVal = top < minVal?top:minVal;
        if(top < 0){
          lastIdx = idx;
          currentAnchor = elem.nativeElement;
        }

        ++idx;
    //  }

    })
    if(currentAnchor)
      this.selectedOfferNav = currentAnchor.name

    // if(minVal < -offset)
    //   this.stuckHeader = true;
    // else
    //   this.stuckHeader = false;

  }
  onSideNavClick(val:string):void{

    const header = this.psb.elementRef.nativeElement.querySelector('h2');
    const margin = header.offsetHeight + (header.offsetTop) - 5;
    let top = 0;
    this.anchors.forEach(elem=> {
      if(elem.nativeElement.name === val){
        top = elem.nativeElement.offsetTop - margin;

        if(top <= 35){
          top = 0;
        }
      }
    });

    this.psb.directiveRef.scrollToY(top,1000);


    //this.selectedOfferNav = val;

  }
  expandPanel(matExpansionPanel: MatExpansionPanel, event: Event) {
    event.stopPropagation()
    if(this._isMenu(event.target) && matExpansionPanel.expanded){
      matExpansionPanel.close();
    }else if(this._isMenu(event.target) && !matExpansionPanel.expanded){
      matExpansionPanel.open();
    }
  }

  // method to patch form values
  private patchFormValues(val:Offer):void{
    let ot:OfferType;
    if(val.offerType){
      if( val.offerType.statusName != 'active') {
        ot = this.inactiveOfferTypes.find(tmp => tmp.id == val.offerType.id );
      } else {
        ot = this.offerTypes.find(tmp => tmp.id == val.offerType.id );
      } 
    }

    if(this.offerFormGroup){
      this.offerFormGroup.patchValue({
        //position : val.position,
        //name : val.name,[Validators.required],
      //  skuList : this.skus,
        offerType : ot?ot:'',
        sellString: val.sellString?val.sellString:'',
        saveString: val.saveString?val.saveString:'',
        sellCombined: val.sellCombined?val.sellCombined:'',
        saveCombined: val.saveCombined?val.saveCombined:'',
        previousPrice: val.previousPrice?val.previousPrice:'',
        offerTypeDescr : ot?ot.name:'',
        offerName : val.offerName,
        callout : val.callout,
        heroSaveStatement : val.heroSaveStatement?val.heroSaveStatement:'',
        salesIndication : val.salesIndication?val.salesIndication:'',
        percentOff : '',
        // disclaimer : val.disclaimer,
        // extraNotes : val.extraNotes,
        // extraText : val.extraText,
        netContent : val.netContent,
        compPriceUnit : val.compPriceUnit,
        contentUnitUom : val.contentUnitUom,

        offerDescr : val.offerDescr,
        //wasDateInput : val.previousDateString, // issue with formatting so will leave as is
        wasDate : val.previousDateString,

        unit : val.unit,
        unitPrice : val.unitPrice,

        multiBuyQuantity:val.multiBuyQuantity,

      });
    }

    if(this.extraOfferFormGroup){
      this.extraOfferFormGroup.patchValue({
        minSpend : val.minSpend,
        packagedOfferDiscountValue : val.packagedOfferDiscountValue,
        // wasDate : val.previousDateString,
        disclaimer : (this.offer.disclaimers && val.disclaimers.length)?val.disclaimers[0].disclaimer:'',
        extraNotes : val.extraNotes,
        extraText : val.extraText,

      });
    }

    if(this.extraInfosFormGroup && val.publicOfferExtraInfos[0]) {
      this.extraInfosFormGroup.patchValue({
        nonMemberCompPriceUnit: (val.publicOfferExtraInfos.find(item => item.label === 'nonMemberCompPriceUnit') || {}).value || '',
        nonMemberSellCombined: (val.publicOfferExtraInfos.find(item => item.label === 'nonMemberSellCombined') || {}).value || '',
        nonMemberContentUnitUom: (val.publicOfferExtraInfos.find(item => item.label === 'nonMemberContentUnitUom') || {}).value || '',
        nonMemberNetContent: (val.publicOfferExtraInfos.find(item => item.label === 'nonMemberNetContent') || {}).value || '',
      });
    }
  }

  // Method to convert to local ISO
  private toISOLocal(d) {
    let result = "";
    if(d instanceof Date){
      var z = n => (n<10? '0':'')+n;
      var off = d.getTimezoneOffset();
      var sign = off < 0? '+' : '-';
      off = Math.abs(off);

      result = d.getFullYear() + '-' + z(d.getMonth()+1) + '-' +
             z(d.getDate()) + 'T' + z(d.getHours()) + ':'  + z(d.getMinutes()) +
             ':' + z(d.getSeconds()) + '.00Z';
             //':' + z(d.getSeconds()) + sign + z(off/60|0) + z(off%60);
    }else{
      result = d;
    }
    return result;

  }

  prepareSaveOffer(): Offer {

      const formModel = this.offerFormGroup.value;
      const extraFormModel = this.extraOfferFormGroup.value;

      // return new `Project` object containing a combination of original project value(s)
      // and deep copies of changed form model values
      const saveOffer: Offer = new Offer();
      saveOffer.uuid = this.offer.uuid;
      saveOffer.code = this.offer.code;
      saveOffer.salesIndication = this.offerFormGroup.controls.salesIndication.value==='.'?'0':this.offerFormGroup.controls.salesIndication.value;
      saveOffer.percentOff = this.offerFormGroup.controls.percentOff.value;

      saveOffer.extraText = extraFormModel.extraText;
      // saveOffer.packagedOffer = this.offerFormGroup.controls.packagedOffer.value;
      // saveOffer.discountValue = this.offerFormGroup.controls.discountValue.value;
      saveOffer.extraNotes = extraFormModel.extraNotes;
      saveOffer.offerName = formModel.offerName;
      saveOffer.offerDescr = formModel.offerDescr;
      saveOffer.offerTypeDescr = formModel.offerType.name;
      saveOffer.offerTypeId = formModel.offerType.id.toString();
      saveOffer.saveString = this.offerFormGroup.controls.saveString.value;
      saveOffer.sellString = this.offerFormGroup.controls.sellString.value;
      saveOffer.saveCombined = this.offerFormGroup.controls.saveCombined.value;
      saveOffer.sellCombined = this.offerFormGroup.controls.sellCombined.value;
      saveOffer.previousPrice = this.offerFormGroup.controls.previousPrice.value;
      saveOffer.previousDateString = "";

      if(formModel.heroSaveStatement)
        saveOffer.heroSaveStatement = formModel.heroSaveStatement.trim();

      if(formModel.wasDate){

        // if it's an date set from the server
        if(formModel.wasDate.value){
          saveOffer.previousDateString = formModel.wasDate.value?this.toISOLocal(formModel.wasDate.value).replace('Z', ''):'';
        }else if(formModel.wasDate instanceof Date){
          // if a date picker object
          saveOffer.previousDateString = formModel.wasDate?this.toISOLocal(formModel.wasDate).replace('Z', ''):'';
        }else if(typeof formModel.wasDate === 'string' ){
          saveOffer.previousDateString = formModel.wasDate?this.toISOLocal(formModel.wasDate).replace('Z', ''):'';
        }

      }

      // saveOffer.minSpend = formModel.minSpend.value;
      saveOffer.netContent = this.offerFormGroup.controls.netContent.value;
      saveOffer.compPriceUnit = this.offerFormGroup.controls.compPriceUnit.value;
      saveOffer.contentUnitUom = this.offerFormGroup.controls.contentUnitUom.value;
      saveOffer.callout = this.offerFormGroup.controls.callout.value;
      saveOffer.unit = this.offerFormGroup.controls.unit.value;
      // saveOffer.unitPrice = this.offerFormGroup.controls.unitPrice.value;
      saveOffer.minSpend = extraFormModel.minSpend;
      saveOffer.department = this.offerFormGroup.controls.team.value.name;
      saveOffer.multiBuyQuantity = this.offerFormGroup.controls.multiBuyQuantity.value;
      saveOffer.packagedOfferDiscountValue = extraFormModel.packagedOfferDiscountValue;
      // saveOffer.toSavings = formModel.toSavings;
      // saveOffer.fromSavings = formModel.fromSavings;
      //saveOffer.publicOfferAssets = this.publicOfferAssets;
      saveOffer.publicOfferAssets = this.productLineFormGroup.getRawValue().items;
      // saveOffer.publicOfferAssets = this.productLineFormGroup.get('items').value;
      saveOffer.publicDecorationAssets = this.assetLineFormGroup.get('items').value;
      // if(this.allocation){
      //   saveOffer.allocationId = this.allocation.id.toString();
      //   //saveOffer.department = this.offerFormGroup.controls.team.value.name;
      // }else{
        // grab the team and allocation position
        // if(this.offerFormGroup.controls.position.value){
          // saveOffer.allocationId = this.offerFormGroup.controls.position.value.id.toString();
        // }

      // }
      if (this.allocation) {
        if (this.offerFormGroup.controls.position.status != 'DISABLED') {
          saveOffer.allocationId = this.offerFormGroup.controls.position.value.id.toString();
        } else {
          saveOffer.allocationId = this.allocation.id.toString();
        }          
      }else{
        // grab the team and allocation position
        if(this.offerFormGroup.controls.position.value){
          saveOffer.allocationId = this.offerFormGroup.controls.position.value.id.toString();
        }
      }

      saveOffer.disclaimers = [];
      // disclaimers
      if(this.offer.disclaimers && this.offer.disclaimers.length){
        var disclaimer = new Disclaimer();
        disclaimer.id = this.offer.disclaimers[0].id;
        // if(extraFormModel.disclaimer.length){
        //   disclaimer.disclaimer = this.offer.disclaimers[0].disclaimer;
        // } else {
        disclaimer.disclaimer = extraFormModel.disclaimer
        // }
        saveOffer.disclaimers.push(disclaimer);
      }
      else if(extraFormModel.disclaimer){
        var disclaimer = new Disclaimer();
        disclaimer.disclaimer = extraFormModel.disclaimer;
        saveOffer.disclaimers.push(disclaimer);
      }

      const extraInfos = [
        {
          label: 'nonMemberNetContent',
          control: 'nonMemberNetContent'
        },
        {
          label: 'nonMemberContentUnitUom',
          control: 'nonMemberContentUnitUom'
        },
        {
          label: 'nonMemberSellCombined',
          control: 'nonMemberSellCombined'
        },
        {
          label: 'nonMemberCompPriceUnit',
          control: 'nonMemberCompPriceUnit'
        }
      ]

      const getExtraInfo = (label: string, controlName: string) => {
        const controlValue = this.extraInfosFormGroup.controls[controlName].value;
        return controlValue !== undefined ? {
            label,
            value: controlValue || '' // Allow empty string but include empty values explicitly
        } : null;
    };

    // If there are existing publicOfferExtraInfos, update them or add new values
    if (this.offer.publicOfferExtraInfos && this.offer.publicOfferExtraInfos.length > 0) {
        saveOffer.publicOfferExtraInfos = this.offer.publicOfferExtraInfos.map(info => {
            // Find the matching label in extraInfos and update the value
            const updatedExtraInfo = extraInfos
                .map(extraInfo => {
                    if (info.label === extraInfo.label) {
                        const newInfo = getExtraInfo(extraInfo.label, extraInfo.control);
                        if (newInfo) {
                            return { ...info, value: newInfo.value }; // Update the value (even to empty)
                        }
                    }
                    return null;
                })
                .find(x => x !== null); // Find the updated one

            // If updated, return it, else keep the existing info
            return updatedExtraInfo || info;
        });

        // Check if there are new values to add (only if non-empty)
        const newExtraInfos = extraInfos
            .map(info => getExtraInfo(info.label, info.control))
            .filter(info => info !== null && info.value !== ''); // Only include non-empty values

        // Add new entries to the array, but avoid duplicates by checking labels
        newExtraInfos.forEach(newInfo => {
            if (!saveOffer.publicOfferExtraInfos.some(info => info.label === newInfo.label)) {
                saveOffer.publicOfferExtraInfos.push(newInfo);
            }
        });
    } else {
        // If no previous extraInfos, create new ones based on the form values
        saveOffer.publicOfferExtraInfos = extraInfos
            .map(info => getExtraInfo(info.label, info.control))
            .filter(info => info !== null && info.value !== ''); // Only include non-empty values
    }

      return saveOffer;
  }

  canSubmit():boolean{

    let status = true;

    for (let control in this.offerFormGroup.controls){
      if(this.offerFormGroup.controls[control] && this.offerFormGroup.controls[control].invalid){

        // for some reason dateControl can't accept null
        if(control === 'wasDate' && !this.offerFormGroup.controls[control].value.value){
          status = true;
        }else{
          status = false;
          break;
        }

      }

    }

    return status;
  }
  // on the offer form submit
  onSubmit():void{
    if(this.canSubmit()){
      let offer = this.prepareSaveOffer();
      const payload = {offer:offer
                       ,job:this.job
                       ,allocation:this.allocation
                       ,documentSegment:this.documentSegment};

      // if this has a new allocation then we need to pass it through so it
      // can be set
      if(this.offerFormGroup.controls.position.value){
        payload.allocation = this.offerFormGroup.controls.position.value;
      }
      this.isSaving = true;
      this.store.dispatch(new UpdateOffer(payload));
    }
  }

  skuSelected(event: MatAutocompleteSelectedEvent): void {
    let skuAdded = this.addSKU(event.option.value);

    if(skuAdded){
      // add new product line
      let pli = new ProductLineItem();
      pli.product = event.option.value;

      this.getProductMedia(event.option.value);

      this.addNewProductLine(pli);


      let productLineControls = this.productLineFormGroup.controls.items['controls'];
      if( this.preferences.poaReadOnly === true) {
        if(productLineControls[productLineControls.length-1].value.liner === false) {
          let lineItemControls = productLineControls[productLineControls.length-1].controls;
          lineItemControls.advsavingsvalue.disable();
          lineItemControls.advsellvalue.disable();
          lineItemControls.assetDescr.disable();
          lineItemControls.discounttype.disable();
          lineItemControls.fromSavings.disable();
          lineItemControls.productqty.disable();
          lineItemControls.savePercent.disable();
          lineItemControls.termType.disable();
          lineItemControls.toSavings.disable();
          lineItemControls.uom.disable();
          lineItemControls.vesselAmount.disable();
        }
      }
    }
  }

  addSKU(sku:Product):boolean{
    let isValid = false;
    if(this.offerFormGroup){
      let ctrl = this.offerFormGroup.controls.skuList;

      let check = this.skus.find(obj => {
        return obj.id == sku.id;
      });

      // if the new sku exists and doesn't already exist.
      if(sku && !check){
        this.skus.push(sku);
        // TODO clear
        if(this.skuInput){
          const input = this.container.nativeElement.querySelector('.sku-input');
          input.value = '';
          //this.skuInput.nativeElement.value = '';
        }

        ctrl.setValue(null);

        this.offerFormGroup.patchValue({skuList: this.skus});

        isValid = true;
        // create a product line
      }
    }
    return isValid;
  }

  onHeroChange(event:any,lineItem:any){
    lineItem.patchValue({isHero: lineItem.controls.isHero.value});
  }

  onLinerChange(event:any,lineItem:any){
    lineItem.patchValue({liner: lineItem.controls.liner.value});

    let lineItemControls = lineItem.controls;
    let linerVal = lineItemControls.liner.value;
    let productItemVal = this.productLineFormGroup.controls.items.value;
    let offerControls = this.offerFormGroup.controls;

    if( this.preferences.poaReadOnly === true) {
      if(linerVal === false) {
        lineItemControls.advsavingsvalue.disable();
        lineItemControls.advsellvalue.disable();
        lineItemControls.assetDescr.disable();
        lineItemControls.discounttype.disable();
        lineItemControls.fromSavings.disable();
        lineItemControls.productqty.disable();
        lineItemControls.savePercent.disable();
        lineItemControls.termType.disable();
        lineItemControls.toSavings.disable();
        lineItemControls.uom.disable();
        lineItemControls.vesselAmount.disable();
      } else {
        lineItemControls.advsavingsvalue.enable();
        lineItemControls.advsellvalue.enable();
        lineItemControls.assetDescr.enable();
        lineItemControls.discounttype.enable();
        lineItemControls.fromSavings.enable();
        lineItemControls.productqty.enable();
        lineItemControls.savePercent.enable();
        lineItemControls.termType.enable();
        lineItemControls.toSavings.enable();
        lineItemControls.uom.enable();
        lineItemControls.vesselAmount.enable();
      }
    }

    //SEG-80
    // for(var i=0; i < productItemVal.length; i++){
    //   if (productItemVal[i].liner === true) {
    //     offerControls.callout.disable();
    //     offerControls.compPriceUnit.disable();
    //     offerControls.contentUnitUom.disable();
    //     offerControls.fromSavings.disable();
    //     offerControls.heroSaveStatement.disable();
    //     offerControls.multiBuyQuantity.disable();
    //     offerControls.netContent.disable();
    //     offerControls.offerDescr.disable();
    //     offerControls.percentOff.disable();
    //     offerControls.previousPrice.disable();
    //     offerControls.salesIndication.disable();
    //     offerControls.saveCombined.disable();
    //     offerControls.saveString.disable();
    //     offerControls.sellCombined.disable();
    //     offerControls.toSavings.disable();
    //     offerControls.unit.disable();
    //     offerControls.wasDate.disable();
    //     offerControls.wasDateInput.disable();

    //     break;
    //   } else {
    //     offerControls.callout.enable();
    //     offerControls.compPriceUnit.enable();
    //     offerControls.contentUnitUom.enable();
    //     offerControls.fromSavings.enable();
    //     offerControls.heroSaveStatement.enable();
    //     offerControls.multiBuyQuantity.enable();
    //     offerControls.netContent.enable();
    //     offerControls.offerDescr.enable();
    //     offerControls.percentOff.enable();
    //     offerControls.previousPrice.enable();
    //     offerControls.salesIndication.enable();
    //     offerControls.saveCombined.enable();
    //     offerControls.saveString.enable();
    //     offerControls.sellCombined.enable();
    //     offerControls.toSavings.enable();
    //     offerControls.unit.enable();
    //     offerControls.wasDate.enable();
    //     offerControls.wasDateInput.enable();
    //   }
    // }
  }

  getOtherItems(val:any):any{
    var result = [];

    for(var lineItem of val){

      var push:boolean = true;
      // if(lineItem.controls.media.value && lineItem.controls.originOwner){
      //   push = false;
      // }
      if(push) result.push(lineItem);
    }
    return result;
  }

  // NOTE THIS IS LAGACY
  onProductMediaHeroChange(event:any,lineItem:any,media:Media):void{
    // uncheck any other media items
    let checked = media.isHero;
    // if checked
    if(checked){
      let pda = new PublicOfferAsset();
      pda.media = media;
      pda.originOwner = media.originOwner?media.originOwner:'';
      this.addMedia(pda);
    }else{
      let items = this.assetLineInfoItems.value;
      for(var i = 0; i < items.length; i++){
        let item = items[i];
        // remove the asset if we've unchecked and the media exists
        if(item.type === SearchType.MEDIA && items[i].media && (items[i].media.uuid === media.uuid)){
          this.removeAsset(item);
          break;
        }
      }

    }
  }

  onProductMediaAlternateChange(event:any,lineItem:any,media:Media):void{
      // uncheck any other media items
      let checked = media.selected;
      let items = this.assetLineInfoItems?this.assetLineInfoItems.value:[];
      this.setSeletedProductMedia(lineItem.value.product,media);

      if(checked && this.offer.publicOfferAssets == undefined){
        let pda = new PublicOfferAsset();
        pda.media = media;
        pda.originOwner = this.productOwnerString(lineItem.value.product);

        if(!media.isHero) {
          this.addMedia(pda);
        }

        for(let i = 0; i < items.length; i++){
          let item = items[i];
          // remove the asset if we've unchecked and the media exists
          if(item.media.selected === false){
            this.removeAsset(item);
          }
          if(item.originOwner === pda.originOwner){
            this.removeAsset(item);
          }

        }
      } else if(checked && this.offer.publicOfferAssets.length < 2){
        // remove the previoly checked item
        for(let i = 0; i < items.length; i++){
          let item = items[i];
          // remove the asset if we've unchecked and the media exists

          if(item.type === SearchType.MEDIA && item.media && (item.media.uuid !== media.uuid) && (item.originOwner && item.originOwner.length)){
            this.removeAsset(item);
            break;
          }
        }
        // don't add if the media is the hero
        if(!media.isHero){
          let pda = new PublicOfferAsset();
          pda.media = media;
          pda.originOwner = this.productOwnerString(lineItem.value.product);
          this.addMedia(pda);
        }

      } else if(checked && this.offer.publicOfferAssets.length >= 2) {
        let pda = new PublicOfferAsset();
        pda.media = media;
        pda.originOwner = this.productOwnerString(lineItem.value.product);
        if(!media.isHero) {
          this.addMedia(pda);
        }
        for(let i = 0; i < items.length; i++){
          let item = items[i];
          // remove the asset if we've unchecked and the media exists
          // if(item.media.selected === false){
          //   this.removeAsset(item);
          // }
          // if(item.originOwner != null){
          //   this.removeAsset(item);
          // }
          if(item.originOwner === pda.originOwner){
            this.removeAsset(item);
          }
        }
      } else {
        for(let i = 0; i < items.length; i++){
          let item = items[i];
          // remove the asset if we've unchecked and the media exists
          if(item.type === SearchType.MEDIA && items[i].media && (items[i].media.uuid === media.uuid)){
            this.removeAsset(item);
            break;
          }
        }

        this.setSeletedProductMedia(lineItem.value.product,null);

      }


  }

  // remove the skus from the list
  removeSKU(sku: any): void {
    let index = this.skus.indexOf(sku);
    if (index >= 0) {
      this.skus.splice(index, 1);
      //TODO need to remove product line item and any media
      this.removeProductLine(sku);
      this.removePublicOfferAsset(sku);
    }
  }

  removeSKUOffers(sku: any): void {
    let index = this.skus.indexOf(sku);
    if (index >= 0) {
      this.skus.splice(index, 1);
      //TODO need to remove product line item and any media
      this.removeProductLineOffers(sku);
      this.removePublicOfferAssetOffers(sku);
    }
  }

  // handler to fetch the sku list
  onSKUKeyUp(event):void{
    let skuControl = this.offerFormGroup.controls.skuList;
    let e:any = {keyword:skuControl.value,includeAssets:false};

    if(this.products.length != 0) {
      this.showAutocomplete = true;
    } else {
      this.showAutocomplete = false;
    }

    // we fetch the first set if the previous keystring is different but only
    // if they've entered the first maxKeyStrokes number of characters
    if(typeof skuControl.value === "string"){
      //if(skuControl.value.length > this.maxKeyStrokes && (skuControl.value.substring(0,this.maxKeyStrokes) != this.prevSearchStr.substring(0,this.maxKeyStrokes))){
      if(skuControl.value.length > this.maxKeyStrokes ){
        this.searchProducts(e);
        this.prevSearchStr = skuControl.value;
        // this.skuPlaceholder = "SKU..."
      }
    }
  }

  onVendorFileUploaded(event):void{
    //console.log(event, ' onVendorFileUploaded');
  }

  getPopover(val:Offer):string{
    let productItems = this.productLineFormGroup.get('items').value;
    
    for ( let i = 0; i < productItems.length; i++) {
      let str;
      let mediaItems = productItems[i].product;

      if ( mediaItems.heroMediaURL === val) {
        // if ( mediaItems.media ) {
          for ( let j = 0; j < mediaItems.media.length; j++) {
            
            if (mediaItems.media[j].selectedMedia === true && mediaItems.media[j].isHero === false ) {
              str = `<img src="${mediaItems.media[j].previewUrl}" style="width:450px;">`;
              break;
            } 
            else if ( mediaItems.media[j].selected === true && mediaItems.media[j].isHero === true ) {
              str = `<img src="${mediaItems.media[j].previewUrl}" style="width:450px;">`;
              break;
            } 
            else {
              str = `<img src="${mediaItems.heroMediaURL}" style="width:450px;">`;
            }
            
          }
          return str;
        // }
      }
    }
  } 

  getPopoverMedia(val:Offer):string{
    let str = `<img src="${val}" style="width:450px;">`;
    return str;
  }

  private productOwnerString(val:Product):string{
    return `Product_${val.uuid}`;
  }
  private filterProducts(val: any, srcArray:any) {
    let tmpName = "";
    let tmpCode = "";
    if(val){
      tmpName = val.descr?val.descr:val;
      tmpCode = val.code?val.code:val;
      var existing = srcArray;
    }

    if(Array.isArray(val)){
      tmpName = val[0].descr;
      tmpCode = val[0].code;
    }

    return this.products.filter(product => {

      let status = false;

      if(product)
        status = (product.descr.toLowerCase().indexOf(tmpName.toLowerCase()) === 0
                  || product.code.toLowerCase().indexOf(tmpCode.toLowerCase()) === 0)

      if(status && existing){
        let tmpProduct = existing.find(sku => sku === product);
        if(tmpProduct)
          status = false;
      }

      return status;

    });

  }

  // works out whether it's a menu click or not
  private _isMenu(target: EventTarget): boolean {
    const expansionIndicatorClass = ['mat-checkbox-inner-container','mat-checkbox-label','mat-checkbox-layout'];
    let element = event.target as HTMLElement;
    return (element.classList && expansionIndicatorClass.indexOf(element.classList[0]) > -1 );
  }

  // destroy subscriptions
  ngOnDestroy():void{
      this.offerStoreSubscription.unsubscribe();
      this.productStoreSubscription.unsubscribe();
      this.authStoreSubscription.unsubscribe();
      this.mediaStoreSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/offer-editor/offer-editor.component.ts